export default "__VITE_ASSET__0f86699f__"